import React from 'react'
import { useTranslation } from 'react-i18next'

import { DeliveryForecastItemForecast } from '../../../../../../data/models'
import {
  ConfigurableTable,
  convertDeliveryForecastItems,
} from '../../../../../../utils/wrapper'
import { useConfigContext } from '../../../../../ui-config'

type Props = {
  items: DeliveryForecastItemForecast[] | undefined
  isLoading: boolean
}

export const ForecastsTable: React.FC<Props> = ({ items, isLoading }) => {
  const { t } = useTranslation()
  const { uiConfig: config } = useConfigContext()

  const headerTitle = t(
    'deliveryForecast.deliveryScheduleDetails.forecasts.title',
  )

  return (
    <>
      <ConfigurableTable
        config={
          config.deliveryForecast.deliveryScheduleDetails.forecastsTable.table
        }
        data={convertDeliveryForecastItems(items)}
        isLoading={isLoading}
        headerTitle={headerTitle}
        dataKey="DeliveryDate"
        stateKey="" //"table-delivery-call-offs-forecasts"
        className="mt-6"
      />
    </>
  )
}
